import {
  ACTION_SIZES,
  ACTION_VARIANTS,
  Button,
  ICON_NAMES,
  Toggle,
} from '@reverse-hr/design-system';
import { Trans, useTranslation } from 'react-i18next';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { showcaseTableSelector } from '@app/store/selectors/showcase-table';

const Header = ({ isRestoreViewButtonVisible, isValidCandidateList }) => {
  const { areDiscardedVisible, areInterestedButVisible, lastSaveDate } =
    useStoreState(showcaseTableSelector);
  const { setDiscardedVisibility, setInterestedButVisibility, resetTable } =
    useStoreActions(showcaseTableSelector);
  const { t } = useTranslation();

  const toggleInterestedButVisibility = () => {
    setInterestedButVisibility(!areInterestedButVisible);
  };

  const toggleDiscardedVisibility = () => {
    setDiscardedVisibility(!areDiscardedVisible);
  };

  const renderResetTable = () =>
    isRestoreViewButtonVisible && (
      <Button
        leftIcon={ICON_NAMES.REFRESH}
        onClick={() => {
          resetTable();
        }}
        size={ACTION_SIZES.SMALL}
        variant={ACTION_VARIANTS.OUTLINED}
      >
        {t('showcase.filters.restoreView')}
      </Button>
    );

  return (
    <>
      <div className="rev-u-px-16 rev-o-col-12 rev-o-col--medium-5">
        <div className="u-hidden-large-down">
          <div className="c-app-intro-flow">
            <p className="c-app-intro-flow__title">{t('showcase.title')}</p>
            {!!lastSaveDate ? (
              <p
                className="c-app-intro-flow__label"
                data-testid="showcase-last-save-date"
              >
                {t('showcase.lastViewUpdate', { date: lastSaveDate })}
              </p>
            ) : null}
            {!isValidCandidateList && (
              <p
                data-testid="showcase-empty-candidate-list-text"
                className="c-app-intro-flow__body"
              >
                <Trans i18nKey="showcase.emptyCandidateList" />
              </p>
            )}
          </div>
        </div>
        <div className="u-hidden-large-up">
          <div className="c-app-intro-flow">
            <p className="c-app-intro-flow__title">{t('showcase.title')}</p>
            <p className="c-app-intro-flow__body">
              <Trans i18nKey="showcase.mobileView">
                0 <strong>1</strong>
              </Trans>
            </p>
          </div>
        </div>
      </div>
      {isValidCandidateList && (
        <div className="rev-u-px-16 rev-o-col-12 rev-o-col--medium-7 u-hidden-large-down">
          <div
            className="rev-u-display-flex rev-u-align-items-center rev-u-gap-24 u-float-right rev-u-py-40"
            data-testid="showcase-filters"
          >
            {renderResetTable()}
            <div
              className="rev-u-display-flex"
              data-testid="showcase-interested-but-candidates-filter"
            >
              <p className="c-app-showcase__filter-label">
                <Trans i18nKey="showcase.filters.interestedBut">
                  0 <strong>1</strong>
                </Trans>
              </p>
              <Toggle
                checkedText={t('showcase.yes')}
                id="show-interested-but"
                isChecked={areInterestedButVisible}
                name="show-interested-but"
                onChange={() => {
                  toggleInterestedButVisibility();
                }}
                uncheckedText={t('showcase.no')}
              />
            </div>
            <div
              className="rev-u-display-flex"
              data-testid="showcase-out-candidates-filter"
            >
              <p className="c-app-showcase__filter-label">
                <Trans i18nKey="showcase.filters.out">
                  0 <strong>1</strong>
                </Trans>
              </p>
              <Toggle
                checkedText={t('showcase.yes')}
                id="show-out-candidates"
                isChecked={areDiscardedVisible}
                name="show-out-candidates"
                onChange={() => {
                  toggleDiscardedVisibility();
                }}
                uncheckedText={t('showcase.no')}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
